import React from 'react';

const Toast = (props) => {
  const { message } = props;
  return (
    <div className="toast-container toast-bottom-right fade-in text-center" aria-live="polite" role="alert">
      <div className={`toast toast-${props.variant || 'success'}`}>
        <div className="toast-message">
          {message}
        </div>
      </div>
    </div>
  );
};
export default Toast;
